import styled from "styled-components";

const ResetPasswordPartnerUsersPanelStyled = styled.div`

`;

export default ResetPasswordPartnerUsersPanelStyled;